<template>
  <div class="plugin-wrapper">
    <div class="layout plugin-blank_space" :style="{height: `${config.height}px`}"></div>
  </div>
</template>

<script>
export default {
  name: "BlankSpace",
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
  .plugin-wrapper {
    .plugin-blank_space {
      min-height: 5px;
    }
  }
</style>